import { render } from "./DeliveryDetails.vue?vue&type=template&id=6cb6c5e6&ts=true"
import script from "./DeliveryDetails.vue?vue&type=script&lang=ts"
export * from "./DeliveryDetails.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__